// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2BWQG","inner":"Footer_inner__2wsvR","nextIcon":"Footer_nextIcon__3Nm_q","innerLeft":"Footer_innerLeft__2m0_h"};